import { createResourceKeys } from "@/lib/resource-context";

export const secretsKeys = createResourceKeys("secrets");
